import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ScheduledTask\DeleteScheduledTaskController::deleteMethod
* @see app/Http/Controllers/ScheduledTask/DeleteScheduledTaskController.php
* @route '/api/scheduled-task/{scheduled_task}'
*/
export const deleteMethod = (args: { scheduled_task: string | number | { id: string | number } } | [scheduled_task: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

deleteMethod.definition = {
    methods: ["delete"],
    url: '/api/scheduled-task/{scheduled_task}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\ScheduledTask\DeleteScheduledTaskController::deleteMethod
* @see app/Http/Controllers/ScheduledTask/DeleteScheduledTaskController.php
* @route '/api/scheduled-task/{scheduled_task}'
*/
deleteMethod.url = (args: { scheduled_task: string | number | { id: string | number } } | [scheduled_task: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { scheduled_task: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { scheduled_task: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            scheduled_task: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        scheduled_task: typeof args.scheduled_task === 'object'
        ? args.scheduled_task.id
        : args.scheduled_task,
    }

    return deleteMethod.definition.url
            .replace('{scheduled_task}', parsedArgs.scheduled_task.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ScheduledTask\DeleteScheduledTaskController::deleteMethod
* @see app/Http/Controllers/ScheduledTask/DeleteScheduledTaskController.php
* @route '/api/scheduled-task/{scheduled_task}'
*/
deleteMethod.delete = (args: { scheduled_task: string | number | { id: string | number } } | [scheduled_task: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\ScheduledTask\DeleteScheduledTaskController::undo
* @see app/Http/Controllers/ScheduledTask/DeleteScheduledTaskController.php
* @route '/api/scheduled-task/{scheduled_task}/undo-delete'
*/
export const undo = (args: { scheduled_task: string | number } | [scheduled_task: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: undo.url(args, options),
    method: 'post',
})

undo.definition = {
    methods: ["post"],
    url: '/api/scheduled-task/{scheduled_task}/undo-delete',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ScheduledTask\DeleteScheduledTaskController::undo
* @see app/Http/Controllers/ScheduledTask/DeleteScheduledTaskController.php
* @route '/api/scheduled-task/{scheduled_task}/undo-delete'
*/
undo.url = (args: { scheduled_task: string | number } | [scheduled_task: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { scheduled_task: args }
    }

    if (Array.isArray(args)) {
        args = {
            scheduled_task: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        scheduled_task: args.scheduled_task,
    }

    return undo.definition.url
            .replace('{scheduled_task}', parsedArgs.scheduled_task.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ScheduledTask\DeleteScheduledTaskController::undo
* @see app/Http/Controllers/ScheduledTask/DeleteScheduledTaskController.php
* @route '/api/scheduled-task/{scheduled_task}/undo-delete'
*/
undo.post = (args: { scheduled_task: string | number } | [scheduled_task: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: undo.url(args, options),
    method: 'post',
})

const DeleteScheduledTaskController = { deleteMethod, undo, delete: deleteMethod }

export default DeleteScheduledTaskController